import * as Yup from "yup"
import {
     CONST_MIME_APPLICATION_DOC,
     CONST_MIME_APPLICATION_DOCX,
     CONST_MIME_APPLICATION_GOOGLE_DOC,
     CONST_MIME_APPLICATION_PDF,
     CONST_MIME_IMAGE_JPEG,
     CONST_MIME_IMAGE_JPG,
     CONST_MIME_IMAGE_PNG,
} from "@common-constants/*"

export interface IFormValuesModel {
     createSuiviSansTemplateOuAvecTemplate: string | "AVEC_TEMPLATE" | "SANS_TEMPLATE"
     template?: number
     notes?: string
     voulezVousProgrammerUneDateDeRelance?: boolean // Included if needed by UI
     dateRelance?: string
     voulezVousJoindreUnDocumentToThisSuivi: boolean
     document?: File
     feeling?: string
     feelingCommentaire?: string
     annonce?: number // Added for context
     candidatType: string // Added for validation context
}

export const initialValues: IFormValuesModel = {
     createSuiviSansTemplateOuAvecTemplate: "SANS_TEMPLATE",
     voulezVousJoindreUnDocumentToThisSuivi: false,
     notes: "",
     candidatType: "",
}

export const EntretienAgenceValidationSchema = Yup.object().shape({
     createSuiviSansTemplateOuAvecTemplate: Yup.string().label(`"Type de suivi"`).required(),
     template: Yup.number()
          .label(`"Template"`)
          .when("createSuiviSansTemplateOuAvecTemplate", {
               is: "AVEC_TEMPLATE",
               then: schema => schema.required(),
          }),
     annonce: Yup.number(),
     notes: Yup.string().label(`"Notes"`),
     voulezVousJoindreUnDocumentToThisSuivi: Yup.boolean(),
     document: Yup.mixed()
          .when("voulezVousJoindreUnDocumentToThisSuivi", {
               is: true,
               then: schema => schema.required(),
          })
          .test("fileFormat", "Seuls les formats word / PDF / image sont acceptés", (value: any) => {
               if (!value) return true
               return [
                    CONST_MIME_IMAGE_JPEG,
                    CONST_MIME_IMAGE_JPG,
                    CONST_MIME_IMAGE_PNG,
                    CONST_MIME_APPLICATION_PDF,
                    CONST_MIME_APPLICATION_DOCX,
                    CONST_MIME_APPLICATION_DOC,
                    CONST_MIME_APPLICATION_GOOGLE_DOC,
               ].includes(value.type)
          })
          .test("fileSize", "Le document ne doit pas dépasser 10MB", (value: any) => {
               if (!value) return true
               return value.size <= 10 * 1024 * 1024
          })
          .label(`"Document"`),
})
